import React from 'react';
import { Upload } from 'lucide-react';

const BannerFormDialog = ({ form, onFormChange, preview, onFileChange, uploading, saving, onConfirm, onClose }) => (
  <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
    <div className="bg-white rounded-2xl shadow-2xl w-full max-w-md">
      <div className="p-6 border-b">
        <h3 className="text-lg font-bold">添加广告图</h3>
      </div>
      <div className="p-6 space-y-4">
        <div>
          <label className="block text-sm font-medium mb-2">广告图片 *</label>
          <div
            className="h-40 bg-gray-50 border-2 border-dashed border-gray-300 rounded-xl overflow-hidden flex items-center justify-center cursor-pointer"
            onClick={() => document.getElementById('bannerUpload').click()}>
            {preview
              ? <img src={preview} alt="preview" className="w-full h-full object-cover" />
              : <div className="text-center">
                  <Upload className="w-8 h-8 mx-auto text-gray-400 mb-2" />
                  <p className="text-sm text-gray-400">点击上传广告图</p>
                  <p className="text-xs text-gray-300">建议 750×300px</p>
                </div>}
          </div>
          <input type="file" id="bannerUpload" accept="image/*"
            onChange={onFileChange} className="hidden" />
        </div>
        <div>
          <label className="block text-sm font-medium mb-1">标题（选填）</label>
          <input type="text" value={form.title}
            onChange={e => onFormChange('title', e.target.value)}
            className="w-full px-3 py-2 border rounded-lg focus:ring-2 focus:ring-blue-500"
            placeholder="例：新品上市" />
        </div>
        <div>
          <label className="block text-sm font-medium mb-1">跳转链接（选填）</label>
          <input type="text" value={form.link_url}
            onChange={e => onFormChange('link_url', e.target.value)}
            className="w-full px-3 py-2 border rounded-lg focus:ring-2 focus:ring-blue-500"
            placeholder="/pages/xxx/index" />
        </div>
        <div>
          <label className="block text-sm font-medium mb-1">排序（数字越小越靠前）</label>
          <input type="number" value={form.sort_order}
            onChange={e => onFormChange('sort_order', parseInt(e.target.value) || 0)}
            className="w-full px-3 py-2 border rounded-lg focus:ring-2 focus:ring-blue-500" />
        </div>
      </div>
      <div className="p-6 border-t flex space-x-3">
        <button onClick={onClose}
          className="flex-1 px-4 py-2 border border-gray-300 rounded-lg text-gray-700 hover:bg-gray-50">
          取消
        </button>
        <button onClick={onConfirm} disabled={saving || uploading}
          className="flex-1 px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 disabled:opacity-50">
          {uploading ? '上传中...' : saving ? '保存中...' : '确认添加'}
        </button>
      </div>
    </div>
  </div>
);

export default BannerFormDialog;